import { ITheme } from '../theme';

import { PaletteColor, SemanticColor, SemanticPaletteColor } from './colors.types';

export const getSemanticPaletteColor: (theme: ITheme, key: SemanticPaletteColor) => string = (theme, key) =>
  theme.palette[key as PaletteColor] || theme.semanticColors[key as SemanticColor];
